"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _country_data = _interopRequireDefault(require("./country_data"));

var _lodash = require("lodash");

var _PhoneNumberModule = _interopRequireDefault(require("./PhoneNumber.module.scss"));

var _DropdownToggle = _interopRequireDefault(require("../Dropdown/DropdownToggle"));

var _DropdownToggleDefault = _interopRequireDefault(require("../Dropdown/DropdownToggleDefault"));

var _DropdownMenu = _interopRequireDefault(require("../Dropdown/DropdownMenu"));

var _DropdownItem = _interopRequireDefault(require("../Dropdown/DropdownItem"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _useRenderDelay = _interopRequireDefault(require("../../hooks/useRenderDelay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PhoneNumber(_ref) {
  var _this = this;

  var props = _extends({}, _ref);

  var formatNumber = function formatNumber(text, patternArg) {
    var pattern;

    if (props.disableCountryCode && patternArg) {
      pattern = patternArg.split(" ");
      pattern.shift();
      pattern = pattern.join(" ");
    } else {
      pattern = patternArg;
    }

    if (!text || text.length === 0) {
      return props.disableCountryCode ? "" : "+";
    }

    if (text && text.length < 2 || !pattern) {
      return props.disableCountryCode ? text : "+".concat(text);
    }

    var formattedObject = (0, _lodash.reduce)(pattern, function (acc, character) {
      if (acc.remainingText.length === 0) {
        return acc;
      }

      if (character !== ".") {
        return {
          formattedText: acc.formattedText + character,
          remainingText: acc.remainingText
        };
      }

      var _acc$remainingText = _toArray(acc.remainingText),
          head = _acc$remainingText[0],
          tail = _acc$remainingText.slice(1);

      return {
        formattedText: acc.formattedText + head,
        remainingText: tail
      };
    }, {
      formattedText: "",
      remainingText: text.split("")
    });
    var formattedNumber;

    if (props.enableLongNumbers) {
      formattedNumber = formattedObject.formattedText + formattedObject.remainingText.join("");
    } else {
      formattedNumber = formattedObject.formattedText;
    } // if (formattedNumber.includes("(") && !formattedNumber.includes(")"))
    //     formattedNumber += ")";


    return formattedNumber;
  };

  var guessSelectedCountry = (0, _lodash.memoize)(function (inputNumber, onlyCountries, defaultCountry) {
    var secondBestGuess = onlyCountries.find(function (o) {
      return o.iso2 == defaultCountry;
    }) || {};
    if (inputNumber.trim() === "") return secondBestGuess;
    var bestGuess = onlyCountries.reduce(function (selectedCountry, country) {
      if ((0, _lodash.startsWith)(inputNumber, country.dialCode)) {
        if (country.dialCode.length > selectedCountry.dialCode.length) {
          return country;
        }

        if (country.dialCode.length === selectedCountry.dialCode.length && country.priority < selectedCountry.priority) {
          return country;
        }
      }

      return selectedCountry;
    }, {
      dialCode: "",
      priority: 10001
    }, _this);
    if (!bestGuess.name) return secondBestGuess;
    return bestGuess;
  });
  var inputNumber = props.value.replace(/[^0-9\.]+/g, "") || "";
  var countryGuess;

  if (inputNumber.length > 1) {
    countryGuess = guessSelectedCountry(inputNumber.substring(0, 6), _country_data.default.allCountries, props.defaultCountry) || 0;
  } else if (props.defaultCountry) {
    countryGuess = _country_data.default.allCountries.find(function (o) {
      return o.iso2 == props.defaultCountry;
    }) || 0;
  } else {
    countryGuess = 0;
  }

  var dialCode = inputNumber.length < 2 && countryGuess && !(0, _lodash.startsWith)(inputNumber.replace(/\D/g, ""), countryGuess.dialCode) ? countryGuess.dialCode : "";
  var initialFormattedNumber;
  initialFormattedNumber = inputNumber === "" && countryGuess === 0 ? "" : formatNumber((props.disableCountryCode ? "" : dialCode) + inputNumber.replace(/\D/g, ""), countryGuess.name ? countryGuess.format : undefined);
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(initialFormattedNumber),
      _useState2 = _slicedToArray(_useState, 2),
      formattedInputNumber = _useState2[0],
      setFormattedInputNumber = _useState2[1];

  var _useState3 = (0, _react.useState)(countryGuess),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCountry = _useState4[0],
      setSelectedCountry = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      freezeSelection = _useState6[0],
      setFreezeSelection = _useState6[1];

  var _useState7 = (0, _react.useState)(props.defaultCountry),
      _useState8 = _slicedToArray(_useState7, 2),
      defaultCountry = _useState8[0],
      setDefaultCountry = _useState8[1];

  var _useState9 = (0, _react.useState)(_country_data.default.allCountries),
      _useState10 = _slicedToArray(_useState9, 2),
      onlyCountries = _useState10[0],
      setOnlyCountries = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      focused = _useState12[0],
      setFocused = _useState12[1];

  var getCountryData = function getCountryData() {
    if (!selectedCountry) return {};
    return {
      name: selectedCountry.name || "",
      dialCode: selectedCountry.dialCode || "",
      countryCode: selectedCountry.iso2 || ""
    };
  };

  var handleInput = function handleInput(e) {
    var formattedNumber = "";
    var newSelectedCountry = selectedCountry;
    var freezeSelection = freezeSelection;
    if (e.target.value.replace(/\D/g, "").length > 15) return;
    if (e.target.value === formattedInputNumber) return;

    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }

    if (e.target.value.length > 0) {
      var _inputNumber = e.target.value.replace(/\D/g, "");

      if (!freezeSelection || selectedCountry.dialCode.length > _inputNumber.length) {
        newSelectedCountry = guessSelectedCountry(_inputNumber.substring(0, 6), onlyCountries, defaultCountry);
        freezeSelection = false;
      }

      formattedNumber = formatNumber(_inputNumber, newSelectedCountry.format);
      newSelectedCountry = newSelectedCountry.dialCode ? newSelectedCountry : selectedCountry;
    }

    setFormattedInputNumber(formattedNumber);
    setFreezeSelection(freezeSelection);
    setSelectedCountry(newSelectedCountry);
    if (props.onChange) props.onChange(formattedNumber, getCountryData());
  };

  var handleFocus = (0, _react.useCallback)(function (e) {
    setFocused(true);

    if (props.onFocus) {
      props.onFocus(e);
    }
  }, [focused, props.onFocus]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setFocused(false);

    if (props.onBlur) {
      props.onBlur(e);
    }
  }, [focused, props.onBlur]);
  var handleClearClick = (0, _react.useCallback)(function (e) {
    setFormattedInputNumber("");
    inputRef.current.focus();

    if (props.onClearClick) {
      props.onClearClick(e);
    }
  }, [inputRef, props.onClearClick]);

  var cursorToEnd = function cursorToEnd() {
    var input = inputRef.current;
    input.focus();
    var len = input.value.length;
    input.setSelectionRange(len, len);
  };

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isOpen = _useState14[0],
      setIsOpen = _useState14[1];

  var toggle = (0, _react.useCallback)(function () {
    inputRef.current.focus();
    setIsOpen(!isOpen);
  }, [isOpen]);
  var dropDelay = (0, _useRenderDelay.default)(isOpen, 10, 250);

  var handleFlagItemClick = function handleFlagItemClick(country) {
    var currentSelectedCountry = selectedCountry;
    var nextSelectedCountry = onlyCountries.find(function (o) {
      return o == country;
    });
    if (!nextSelectedCountry) return;
    var unformatedNumber = formattedInputNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", "");
    var newNumber = unformatedNumber.length > 1 ? unformatedNumber.replace(currentSelectedCountry.dialCode, nextSelectedCountry.dialCode) : nextSelectedCountry.dialCode;
    var formattedNumber = formatNumber(newNumber.replace(/\D/g, ""), nextSelectedCountry.format);
    setFormattedInputNumber(formattedNumber);
    setSelectedCountry(nextSelectedCountry);
    setFreezeSelection(true);
    setIsOpen(false);
    cursorToEnd();

    if (props.onChange) {
      props.onChange(formattedNumber.replace(/[^0-9]+/g, ""), getCountryData());
    }
  };

  var selectedItem = selectedCountry && _country_data.default.allCountries.filter(function (i) {
    return i.dialCode + i.iso2 === selectedCountry.dialCode + selectedCountry.iso2;
  })[0];

  var classes = (0, _classnames.default)(_PhoneNumberModule.default.inputBlock, props.disabled && _PhoneNumberModule.default.disabled, props.size === "sm" && _PhoneNumberModule.default.sm || props.size === "lg" && _PhoneNumberModule.default.lg, props.validation === "success" && _PhoneNumberModule.default.success || props.validation === "warning" && _PhoneNumberModule.default.warning || props.validation === "error" && _PhoneNumberModule.default.error, focused && "focused" && _PhoneNumberModule.default.focused, props.value && _PhoneNumberModule.default.nonEmpty);
  return _react.default.createElement("div", {
    className: classes
  }, props.label && _react.default.createElement("label", {
    className: _PhoneNumberModule.default.label
  }, props.label), _react.default.createElement("div", {
    className: _PhoneNumberModule.default.inputContainer
  }, _react.default.createElement("input", _extends({
    name: props.name,
    className: _PhoneNumberModule.default.input,
    ref: inputRef,
    type: "tel",
    placeholder: props.placeholder,
    value: formattedInputNumber,
    onChange: handleInput,
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props.attributes)), formattedInputNumber && _react.default.createElement("div", {
    className: _PhoneNumberModule.default.clearButton,
    onClick: handleClearClick
  }, _react.default.createElement("i", {
    className: "icon-close"
  })), _react.default.createElement("div", {
    className: _PhoneNumberModule.default.dropdownWrap
  }, _react.default.createElement(_Dropdown.default, {
    isOpen: dropDelay.isOpen,
    toggle: toggle,
    nonEmpty: selectedItem,
    size: props.size,
    disabled: props.disabled
  }, _react.default.createElement("div", {
    className: _PhoneNumberModule.default.dropdownToggleWrap
  }, _react.default.createElement(_DropdownToggle.default, null, _react.default.createElement(_DropdownToggleDefault.default, null, selectedItem ? _react.default.createElement("span", {
    className: "".concat(_PhoneNumberModule.default.flag, " ").concat(_PhoneNumberModule.default[selectedItem.iso2 || "ps"])
  }) : _react.default.createElement("span", {
    className: _PhoneNumberModule.default.flag
  })))), dropDelay.isRender && _react.default.createElement("div", {
    className: _PhoneNumberModule.default.dropdownMenuWrap
  }, _react.default.createElement(_DropdownMenu.default, null, _country_data.default.allCountries.map(function (country, index) {
    return _react.default.createElement(_DropdownItem.default, {
      key: country.name + index,
      onClick: function onClick() {
        handleFlagItemClick(country);
      },
      selected: selectedItem && selectedItem.dialCode + selectedItem.iso2 === country.dialCode + country.iso2
    }, _react.default.createElement("span", {
      className: "".concat(_PhoneNumberModule.default.flag, " ").concat(_PhoneNumberModule.default[country.iso2])
    }), country.name + " " + "+(" + country.dialCode + ")");
  })))))), props.message && props.validation && !props.disabled && _react.default.createElement("div", {
    className: _PhoneNumberModule.default.validationMessage
  }, props.message));
}

var _default = PhoneNumber;
exports.default = _default;